import { render, staticRenderFns } from "./StudentRecruiterComponent.vue?vue&type=template&id=44ffc76c&"
import script from "./StudentRecruiterComponent.vue?vue&type=script&lang=ts&"
export * from "./StudentRecruiterComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44ffc76c')) {
      api.createRecord('44ffc76c', component.options)
    } else {
      api.reload('44ffc76c', component.options)
    }
    module.hot.accept("./StudentRecruiterComponent.vue?vue&type=template&id=44ffc76c&", function () {
      api.rerender('44ffc76c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StudentDashboard/Gains/StudentRecruiterComponent.vue"
export default component.exports